/*
  The message thread list item is message or messages in a thread
  displayed in the ContentPanel.
*/

import React, { Component } from 'react';
import { object, string } from 'prop-types';
import linkifyHtml from 'linkifyjs/html';

import * as str from '../../../../lib/string_utils';

import s from './MessageThreadListItem.css';


export default class MessageThreadListItem extends Component {
  static propTypes = {
    content: string,
    formElements: object,
  };

  render() {
    const {
      content,
      formElements,
      expanded,
    } = this.props;
    const truncatedContent = formElements == null ? str.ellipsis(content, 30) : str.ellipsis(formElements.title.toString(), 30);

    function renderContent(){
      if(formElements == null) {
        if(content == null) {
          return (
              <p className={s.content} dangerouslySetInnerHTML={{__html: content}} />
          );
        }
        const finalContent = linkifyHtml(content, {
          attributes: {
            rel: 'noopener noreferrer'
          },
          ignoreTags: ['script', 'style'],
          validate: {
            url: function(value) {
              if (/\.js\/?$/.test(value)) {
                return false;
              } else {
                return true;
              }
            },
            email: function(value) {
              return false;
            }
          }
        });

        return (
              <p className={s.content} dangerouslySetInnerHTML={{__html: finalContent}} />
        );
      }
      return (
        <div className={s.content}>
          <h3>{formElements.title}</h3>
            <table className={s.table}>
              <tbody className={s.tbody}>
                {formElements.fields.map(field => {
                  return renderField(field);
                })}
              </tbody>
            </table>
        </div>);
    }

    function renderMobileContent(){
      if (!expanded) {
        return ( <p className={s.contentMobile} dangerouslySetInnerHTML={{__html: truncatedContent}} />);
      }
      if(formElements == null) {
        if(content == null) {
          return (
              <p className={s.content} dangerouslySetInnerHTML={{__html: content}} />
          );
        }
        const finalContent = linkifyHtml(content, {
          attributes: {
            rel: 'noopener noreferrer'
          },
          ignoreTags: ['script', 'style'],
          validate: {
            url: function(value) {
              if (/\.js\/?$/.test(value)) {
                return false;
              } else {
                return true;
              }
            },
            email: function(value) {
              return false;
            }
          }
        });

        return (
              <p className={s.contentMobile} dangerouslySetInnerHTML={{__html: finalContent}} />
        );
      }
      return (
          <div className={s.contentMobile}>
            <h3>{formElements.title}</h3>
            <table className={s.table}>
              <tbody className={s.tbody}>
                {formElements.fields.map(field => {
                  return renderField(field);
                })}
              </tbody>
            </table>
          </div>
      );
    }

    function renderField(field) {
      if(field.type==="spacer"){
        return null;
      }
      if((field.type==="label") || (field.type==="section")) {
        return (
          <tr key={field.id} className={s.tr}>
            <td colSpan={2} className={s.td}>{field.label}</td>
          </tr>
        );
      }
      if(field.type==="checkbox") {
        return (
          <tr key={field.id} className={s.tr}>
            <td className={s.fieldLabel}>{field.label}</td>
            <td className={s.td}>{((field.value !== null && field.value !== undefined && field.value.trim() !== "") && (field.value===field.label || field.value.toLowerCase()==="true")) ? "yes" : "no"}</td>
          </tr>
        );
      }
      if(field.type==="checklist") {
        return (
            <tr key={field.id} className={s.tr}>
              <td className={s.fieldLabel}>{field.label}</td>
              { renderChecklist(field) }
            </tr>
        );
      }
      return (
        <tr key={field.id} className={s.tr}>
          <td className={s.fieldLabel}>{field.label}</td>
          <td className={s.td}>{field.value}</td>
        </tr>
      );
    }

    function renderChecklist(field){
      if(Array.isArray(field.value)){
        return (
            <td className={s.td}>
                <ul className={s.list}>
                  {field.value.map(checkListItem => {
                    return (
                        <li>{checkListItem}</li>
                    );
                  })}
                </ul>
            </td>
        );
        return null;
      }
    }

    return (
      <div>
        {renderContent()}
        {renderMobileContent()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadListItem/MessageThreadListItemContent.js